import { memo } from "react";

export const AheadCaretIcon = memo(() => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.31348 6L1.65662 11.6569L0.402844 10.4031L4.80592 6L0.402844 1.59692L1.65662 0.343146L7.31348 6Z"
        fill="#323232"
      />
    </svg>
  );
});
